<script>
import authenticationService from '@/services/Authentication/authenticationService.js';
import pessoasService from '@/services/Pessoas/pessoasService';
import { vueTopprogress } from 'vue-top-progress';

import Vue from 'vue';

import HelperPlugin from '@/plugins/HelperPlugin';
import { email } from 'vuelidate/lib/validators';
Vue.use(HelperPlugin);

import { cpf } from '@/validate/customValidators.js';

import settingsService from '@/services/Settings/settingsService';

export default {
  components: {
    vueTopprogress,
  },
  data() {
    return {
      modalidade: process.env.VUE_APP_TYPE,
      submodalidade: process.env.VUE_APP_SUBTYPE,
      user: {},
      envPath: process.env.VUE_APP_ROOT_SITE,
      logoUrl: require(process.env.VUE_APP_LOGO_URL),
      cpfAtivo: false,
      emailAtivo: true,
      emailToShow: '',
      titulo: '',
    };
  },
  validations: {
    user: {
      email: {
        valid: email,
      },
      cpf: {
        valid: cpf,
      },
    },
  },
  mounted() {
    this.checkUserLogged();
    this.getSettings();
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE;
    },
    loggedInUser() {
      return this.$store.getters.isLoggedIn;
    },
    investorLogged() {
      return this.$store.getters.isLoggedInvestor;
    },
    ref() {
      return this.$route.params.ref;
    },
  },
  methods: {
    redirectTo() {
      this.$router.push('/dashboard');
    },
    async getSettings() {
      let privateSettings = (await settingsService.getPrivateSettings()) || {};

      this.titulo = privateSettings.platformName || '';
    },
    checkUserLogged() {
      if (Object.keys(this.loggedInUser).length > 0) {
        this.redirectTo();
      }
    },
    navigateToSite() {
      this.$router.push('/login');
    },
    changeToCpf() {
      this.cpfAtivo = true;
      this.emailAtivo = false;
    },
    changeToEmail() {
      this.cpfAtivo = false;
      this.emailAtivo = true;
    },
    async recoveryPassword() {
      var cpfError = this.cpfAtivo ? !this.$v.user.cpf.valid : false;
      var emailError = this.emailAtivo ? !this.$v.user.email.valid : false;

      if (cpfError || emailError) {
        return this.$notify({
          title: 'Informe os dados corretamente!',
          message:
            'Um ou mais dados informados não foram preenchidos corretamente.',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 7000,
        });
      }

      const { email, cpf } = this.user;
      var emailToSend = email;
      this.emailToShow = '';

      this.$refs.topProgress.start();

      try {
        if (this.cpfAtivo) {
          const pessoasFound = await pessoasService.searchByPrincipalDocument(
            cpf,
          );
          if (pessoasFound.size == 0) {
            this.$notify({
              title: 'Ooppss!',
              message:
                'Você não possui cadastro. Por favor, faça seu cadastro.',
              icon: 'tim-icons icon-bell-55',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'warning',
              timeout: 3000,
            });
            this.$refs.topProgress.done();
            return;
          }
          const pessoaFirebaseFound = pessoasFound.docs[0];
          const pessoaFound = pessoaFirebaseFound.data();
          emailToSend = pessoaFound.email.email;
        }

        console.log('[recoveryPassword] email que será enviado ao Firebase:', emailToSend);
        if (!emailToSend) {
          this.$notify({
            title: 'Ooppss!',
            message: 'Não foi possível identificar o e-mail cadastrado.',
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning',
            timeout: 3000,
          });
          this.$refs.topProgress.done();
          return;
        }
        
        await authenticationService.updatePassword(emailToSend);

        this.emailToShow = emailToSend.substring(0, 3) + '***********';

        this.$notify({
          title: 'Enviado com Sucesso!',
          message: 'Email de recuperação de senha enviado com sucesso',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success',
          timeout: 3000,
        });

        this.$refs.topProgress.done();
      } catch (error) {
        console.log(error);
        this.$notify({
          title: 'Ooppss!',
          message: 'Ocorreu um erro ao enviar o e-mail de recuperação!',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });

        this.$refs.topProgress.done();
      }
    },
  },
};
</script>

<template>
  <div class="sign-in">
    <div class="signin2"></div>
    <div class="card">
      <div class="back" style="margin-top: -30px !important">
        <i class="fa fa-arrow-left" @click="navigateToSite()"></i>
      </div>

        <img class="auth-logo" :src="logoUrl" alt="">
      <p style="text-align: center">
        Digite seu e-mail ou seu CPF para receber um link de recuperação
      </p>

      <form @submit.prevent="recoveryPassword()" class="login-form">
        <div class="form-group" v-if="emailAtivo">
          <label for="" class="control-label">Email</label>
          <input
            v-model="user.email"
            data-testId="email"
            type="email"
            class="form-control"
            placeholder="email@dominio.com"
            required
          />
          <div class="error" v-if="user.email != '' && !$v.user.email.valid">
            Informe um e-mail válido.
          </div>
        </div>

        <div class="form-group" v-if="cpfAtivo">
          <label for="" class="control-label">CPF</label>
          <input
            v-model="user.cpf"
            data-testId="cpf"
            type="cpf"
            class="form-control"
            placeholder="999.999.999-99"
            v-mask="'###.###.###-##'"
            required
          />
          <div class="error" v-if="user.cpf != '' && !$v.user.cpf.valid">
            Informe um CPF válido.
          </div>
        </div>

        <div class="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            class="btn"
            :class="{ active: emailAtivo }"
            @click="changeToEmail"
          >
            Informar e-mail
          </button>

          <button
            type="button"
            class="btn"
            :class="{ active: cpfAtivo }"
            @click="changeToCpf"
          >
            Informar CPF
          </button>
        </div>
        <button
          type="submit"
          class="btn btn-primary"
          style="background-color: #549c40 !important; color: white !important;"
        >
          Enviar e-mail
        </button>
        <br />
        <br />
        <p
          style="text-align: center; font-size: 12px; font-style: italic"
          v-if="emailToShow.length != ''"
        >
          Um e-mail foi enviado para: <b>{{ emailToShow }}</b>
        </p>
      </form>
    </div>

    <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>
</template>

<style scoped>

/* container da tela */
.sign-in {
  background: var(--imob-bg);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* remover overlay antigo herdado */
.signin2 {
  display: none;
}

/* card central */
.sign-in > .card {
  background: var(--imob-white);
  border-radius: 8px;
  border: 1px solid var(--imob-border);
  box-shadow: var(--imob-header-shadow);
  padding: 2rem;
  width: 420px;
}

/* logo */
.auth-logo {
  display: block;
  margin: 0 auto 28px auto;
  height: 56px;
}

/* texto */
p {
  color: var(--imob-text-muted);
  text-align: center;
  margin-bottom: 20px;
}

/* labels */
.control-label {
  color: var(--imob-text);
  font-weight: 500;
}

/* inputs */
.form-control {
  border: 1px solid var(--imob-border);
  border-radius: 6px;
  color: var(--imob-text);
  background: var(--imob-white);
  padding: 10px 14px;
  transition: border 0.15s ease;
}

/* foco no input */
.form-control:focus {
  border-color: var(--imob-magenta);
  outline: none;
  box-shadow: 0 0 0 2px rgba(237,34,139,0.1);
}

/* erro */
.error {
  color: var(--imob-magenta);
  font-size: 13px;
}

/* grupo de botões (email / cpf) */
.btn-group {
  display: flex;
  gap: 12px;
  margin-top: 14px;
}

/* botões padrão */
.btn-group .btn {
  flex: 1;
  border-radius: 999px;
  border: 1px solid var(--imob-border);
  background: var(--imob-white);
  color: var(--imob-text);
  font-weight: 500;
  transition: all 0.15s ease;
}

/* hover neutro */
.btn-group .btn:hover {
  background: rgba(237,34,139,0.08);
  color: var(--imob-magenta);
}

/* botão ativo (igual LOGIN do header) */
.btn-group .btn.active {
  background: var(--imob-gradient);
  color: var(--imob-white);
  border: none;
  box-shadow: 0 4px 10px rgba(237,34,139,0.25);
}

/* botão principal enviar */
button.btn-primary {
  width: 100%;
  margin-top: 22px;
  border-radius: 999px;
  background: var(--imob-gradient);
  border: none;
  color: var(--imob-white);
  font-weight: 500;
  padding: 12px;
  transition: opacity 0.15s ease;
}

button.btn-primary:hover {
  opacity: 0.9;
}

/* botão voltar */
.back i {
  color: var(--imob-text);
  cursor: pointer;
}

</style>